import { Record } from 'immutable';

export const Model = <T>(data: any): any => {
    return Record(data);
};